import type { ClientTheme } from "@/app/lib/themes"

export interface OrriEntry {
  id: string
  str: string
  township_range: string
  orri: string
  net_acres_burdened: string
  mineral_transaction: {
    id: string
    tx_number: string
    transaction_date: string
  }
}

interface Props {
  entry: OrriEntry
  index: number
  hoveredRow: number | null
  onMouseEnter: () => void
  onMouseLeave: () => void
  orriMin: number
  orriMax: number
  theme: ClientTheme
}

export function ORRIRow({
  entry,
  index,
  hoveredRow,
  onMouseEnter,
  onMouseLeave,
  orriMin,
  orriMax,
  theme,
}: Props) {
  const orriNum = Number(entry.orri)
  const orriPct = orriMax > orriMin ? ((orriNum - orriMin) / (orriMax - orriMin)) * 100 : 50

  return (
    <tr
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        borderBottom: `1px solid ${theme.borderSubtle}`,
        backgroundColor: hoveredRow === index ? theme.bgSurface2 : theme.bgSurface,
        transition: "background-color 120ms ease",
      }}
    >
      <td className="px-5 py-3.5">
        <span
          style={{
            fontFamily: "var(--font-data)",
            fontSize: "12px",
            fontWeight: 500,
            color: theme.textPrimary,
          }}
        >
          {entry.mineral_transaction.tx_number}
        </span>
      </td>
      <td className="px-5 py-3.5">
        <span style={{ fontFamily: "var(--font-ui)", fontSize: "12px", color: theme.textMuted }}>
          {entry.mineral_transaction.transaction_date}
        </span>
      </td>
      <td className="px-5 py-3.5">
        <span
          style={{
            fontFamily: "var(--font-data)",
            fontSize: "13px",
            fontWeight: 500,
            color: theme.textPrimary,
            letterSpacing: "0.02em",
          }}
        >
          {entry.str}
        </span>
      </td>
      <td className="px-5 py-3.5">
        <span style={{ fontFamily: "var(--font-ui)", fontSize: "12px", color: theme.textMuted }}>
          {entry.township_range}
        </span>
      </td>
      <td className="px-5 py-3.5">
        <div className="flex flex-col gap-1.5">
          <span
            className="inline-block px-2.5 py-0.5 rounded-full"
            style={{
              fontFamily: "var(--font-data)",
              fontSize: "11px",
              fontWeight: 600,
              backgroundColor: `${theme.brandTeal}20`,
              color: theme.brandTeal,
              width: "fit-content",
            }}
          >
            {(orriNum * 100).toFixed(4)}%
          </span>
          <div
            className="w-16 h-1.5 rounded-full overflow-hidden"
            style={{ backgroundColor: theme.borderColor }}
          >
            <div
              className="h-full rounded-full"
              style={{
                width: `${orriPct}%`,
                background: `linear-gradient(90deg, ${theme.brandTeal} 0%, ${theme.brandPrimary} 100%)`,
              }}
            />
          </div>
        </div>
      </td>
      <td className="px-5 py-3.5 text-right">
        <span
          style={{
            fontFamily: "var(--font-data)",
            fontSize: "13px",
            fontWeight: 500,
            color: theme.textPrimary,
          }}
        >
          {Number(entry.net_acres_burdened).toFixed(4)}
        </span>
      </td>
    </tr>
  )
}
